module.exports = __webpack_public_path__ + "static/media/footer_bg.3f157b19.jpg";